module.exports = __webpack_public_path__ + "static/media/lc100_2.2e87b044.png";